var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIconCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.75H10C9.30964 8.75 8.75 9.30964 8.75 10V20C8.75 20.6904 9.30964 21.25 10 21.25H20C20.6904 21.25 21.25 20.6904 21.25 20V10C21.25 9.30964 20.6904 8.75 20 8.75Z",
    fill: "#E5E7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.5H10C8.61875 7.5 7.5 8.61875 7.5 10V20C7.5 21.3813 8.61875 22.5 10 22.5H20C21.3813 22.5 22.5 21.3813 22.5 20V10C22.5 8.61875 21.3813 7.5 20 7.5ZM21.25 20C21.25 20.6875 20.6875 21.25 20 21.25H10C9.3125 21.25 8.75 20.6875 8.75 20V10C8.75 9.3125 9.3125 8.75 10 8.75H20C20.6875 8.75 21.25 9.3125 21.25 10V20Z",
    fill: "#99A1AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3438 10.0312H10.6562C10.3111 10.0312 10.0312 10.3111 10.0312 10.6562V19.3438C10.0312 19.6889 10.3111 19.9688 10.6562 19.9688H19.3438C19.6889 19.9688 19.9688 19.6889 19.9688 19.3438V10.6562C19.9688 10.3111 19.6889 10.0312 19.3438 10.0312Z",
    fill: "#99A1AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14H11.5V16H18.5V14Z",
    fill: "#E5E7EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIconCheckbox);
export default __webpack_public_path__ + "static/media/ic-icon-checkbox.ba98ce32c6d2e8fe9e3ac034704ebbfd.svg";
export { ForwardRef as ReactComponent };